import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('DocumentFilter', DocumentFilterData);

    DocumentFilterData.$inject = [];

    function DocumentFilterData() {
        DocumentFilter.prototype = {
            setPage: setPage,
            setPageSize: setPageSize,
            setSorts: setSorts,
            setBuyer: setBuyer,
            setPrincipalId: setPrincipalId,
            setDocumentNumber: setDocumentNumber,
            setCreationDateFrom: setCreationDateFrom,
            setCreationDateTo: setCreationDateTo,
            setUpdateDateFrom: setUpdateDateFrom,
            setUpdateDateTo: setUpdateDateTo,
            setDocumentTypes: setDocumentTypes,
            setStatus: setStatus,
            setGuid: setGuid,
            setDocumentOptions: setDocumentOptions,
            setSender: setSender,
        };

        function DocumentFilter() {
            this.pageCriteria = {};
            this.documentOptions = [];
            this.sens = 'EM';
        }

        return DocumentFilter;

        /////////////////////

        /**
         * Ajoute un client dans les critères de recherches.
         * @param buyerId Identifiant du  client
         * @param perimetersCode Liste des périmètres du client
         */
        function setBuyer(buyerId, perimeterCodes) {
            this.buyers = [];
            if (perimeterCodes) {
                for (var i = 0; i < perimeterCodes.length; i++) {
                    var buyerTmp = { buyerId, perimeterCode: perimeterCodes[i].code };
                    this.buyers[i] = buyerTmp;
                }
            } else {
                buyerTmp = { buyerId };
                this.buyers[0] = buyerTmp;
            }
        }

        function setSender(seller) {
            if (seller && seller.legalEntity) {
                this.companies = [
                    {
                        id: seller.legalEntity.id,
                    },
                ];
            }
        }

        /**
         * Indiquer la page.
         */
        function setPage(page) {
            this.pageCriteria.page = page;
        }

        /**
         * Changement de pagination.
         */
        function setPageSize(pageSize) {
            this.pageCriteria.pageSize = pageSize;
        }

        /**
         * Changement de tri.
         */
        function setSorts(sorts) {
            this.pageCriteria.sorts = sorts;
        }

        /** Filtre sur un DO. */
        function setPrincipalId(principalId) {
            this.principalId = principalId;
        }

        /**
         * Ajoute une liste de numéros de commande/facture/contrat.
         * @param senderDocRefs Numéro ou liste de numéros
         */
        function setDocumentNumber(senderDocRefs) {
            this.senderDocRef = senderDocRefs;
        }

        /** Filtre la date de création minimal du document. */
        function setCreationDateFrom(dateFrom) {
            this.creationDateFrom = dateFrom;
        }

        /** Filtre la date de création maximal du document. */
        function setCreationDateTo(dateTo) {
            this.creationDateTo = dateTo;
        }

        /** Filtre la date de modification minimal du document. */
        function setUpdateDateFrom(dateFrom) {
            this.updateDateFrom = dateFrom;
        }

        /** Filtre la date de modification maximal du document. */
        function setUpdateDateTo(dateTo) {
            this.updateDateTo = dateTo;
        }

        /** Filtre sur le type de document.
         * @param documentTypes Liste de types de document
         */
        function setDocumentTypes(documentTypes) {
            this.documentTypes = documentTypes;
        }

        /** Filtre sur les statuts d'un document.
         * @param status Liste de status
         */
        function setStatus(status) {
            this.status = status;
        }

        /**
         * Recherche une commande avec son guid
         * @param guid Guid de la commande
         */
        function setGuid(guid) {
            this.guid = guid;
        }

        /**
         * Permet d'enrichir les Dtos retournés.
         */
        function setDocumentOptions(options) {
            this.documentOptions = options;
        }
    }
})();
